module.exports = __webpack_public_path__ + "static/img/pic3@2x.7dd9ae1b.png";